import React, { useEffect, useRef } from "react";
import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import { useAppSelector } from "../../hooks/reduxHooks";
import { loginRequest } from "../../config/authConfig";

/**
 * Component props interface
 */
interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const isAuthenticated = useIsAuthenticated();
  const { inProgress, instance } = useMsal();
  const isReduxAuthenticated = useAppSelector(state => state.userAuthAndAdminSlice.isAuthenticated);

  // Auto-redirect to Microsoft login
  const hasRedirected = useRef(false);

  useEffect(() => {
    if (!isAuthenticated && !isReduxAuthenticated && inProgress === "none" && !hasRedirected.current) {
      hasRedirected.current = true;
      instance.loginRedirect(loginRequest);
    }
  }, [isAuthenticated, isReduxAuthenticated, inProgress, instance]);

  if (inProgress === "startup" || inProgress === "login") {
    return (
      <div className="min-h-screen bg-gray-100 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
          <p className="text-gray-600">Authenticating...</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated && !isReduxAuthenticated) {
    // Show loading while redirect initiates
    return (
      <div className="min-h-screen bg-gray-100 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
          <p className="text-gray-600">Redirecting to sign in...</p>
        </div>
      </div>
    );
  }

  return children;
};

export default ProtectedRoute;